import React from "react";

import classNames from "classnames";
import { Col } from "shards-react";

import SidebarMainNavbar from "./SidebarMainNavbar";
import SidebarSearch from "./SidebarSearch";
import SidebarNavItems from "./SidebarNavItems";

const  MainSidebar = () =>{
    const classes = classNames(
      "main-sidebar",
      "px-0",
      "col-12",
      "open"
    );

    return (
      <Col style={{zIndex:999}} tag="aside" className={classes} lg={{ size: 2 }} md={{ size: 3 }}>
        <SidebarMainNavbar hideLogoText={true} />
        <SidebarSearch />
        <SidebarNavItems />
      </Col>
    );
  }



export default MainSidebar;
